import { Link } from "react-router-dom";
import fourHEmblem from "../assets/fourHEmblem.png";
import "../styles/Logo.css";

export default function Logo() {
  return (
    <Link
      to="/fourh"
      className="fourHLogo"
      aria-label="Go to the FourH homepage"
    >
      <img
        className="logoImage"
        src={fourHEmblem}
        alt="4-H emblem"
      />
    </Link>
  );
}